/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Spreadsheet_Rows_LabelInputs */



/**
* | output |
* | --- |
* | "rows" |
*
* @param {Spaces_Spreadsheet_Rows_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_spreadsheet_rows_label = /** @type {((inputs?: Spaces_Spreadsheet_Rows_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Spreadsheet_Rows_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilen")
	return /** @type {LocalizedString} */ ("rows")
});